import { Card, CardContent } from "@mui/material";
import * as React from 'react';
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Link, Route, Routes } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
export default function Home() {
  return (
    <Box sx={{ flexGrow: 1, marginLeft: '5vw',marginRight: '5vw',marginTop:'1vh',height:"50%" }}>
    <Grid container spacing={{ xs: 1, md: 3 }} columns={{ xs: 1, sm: 1, md: 12, lg: 12 }}>
    <Grid item xs={1} sm={1} md={12} lg={3}>
    <Link to="/diensten" style={{ textDecoration: "none", color: "#e4dbdc" }}>

          <Item>
          <h2>Boekhouding</h2>
          <p>Een transparante en bruikbaar beleidsboekhouding</p>
        </Item></Link>
      </Grid>
      <Grid item xs={1} sm={1} md={12} lg={3}>
      <Link to="/diensten" style={{ textDecoration: "none", color: "#e4dbdc" }}>

          <Item>
          <h2>Fiscaliteit</h2>
          <p>Van BTW-aangifte tot venootschapsbelasting</p>
        </Item></Link>
      </Grid>
      <Grid item xs={1} sm={1} md={12} lg={3}>
      <Link to="/diensten" style={{ textDecoration: "none", color: "#e4dbdc" }}>

          <Item>
          <h2>Juridisch advies</h2>
          <p>Aktes, overeenkomsten en contracten</p>
        </Item></Link>
      </Grid>
      <Grid item xs={1} sm={1} md={12} lg={3}>
      <Link to="/diensten" style={{ textDecoration: "none", color: "#e4dbdc" }}>

          <Item>
          <h2>Startersbegeleiding</h2>
          <p>De eerste stappen naar een eigen zaak</p>
        </Item></Link>
      </Grid>
      </Grid>
  </Box>




  );
}
